export const storageKeyDisableThirdPartyScripts = "@mc/scripts/disable";

/**
 * Returns true if third party scripts are disabled from local storage, false otherwise.
 */
export const areThirdPartyScriptsDisabled = () =>
    window.localStorage.getItem(storageKeyDisableThirdPartyScripts) === "true";
